import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducer/userSlice';
import reposReducer from './reducer/reposSlice';
import paginateReducer from './reducer/paginateSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    repos: reposReducer,
    paginate: paginateReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
